import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import Root from './pages/root';
// eslint-disable-next-line
import { iframeResizerContentWindow } from 'iframe-resizer';
const isIframe = window.self !== window.top;

const intervalId = setInterval(() => {
  if (window.parentIFrame) {
    window.parentIFrame.getPageInfo(data => {
      window.parentViewportHeight = data.clientHeight;
      render();
    });
  }
}, 100);

const render = () => {
  clearInterval(intervalId);
  ReactDOM.render(<Root />, document.getElementById('root'));
};

if (!isIframe) {
  window.parentViewportHeight = window.innerHeight;
  render();
}

if (module.hot) {
  module.hot.accept('./pages/root', function() {
    ReactDOM.render(<Root />, document.getElementById('root'));
  });
}



// WEBPACK FOOTER //
// ./src/index.js